{
  "tabs": {
    "chat": "ቻት",
    "reminders": "ኣርእስታታት",
    "calendar": "ካሌንደር",
    "settings": "ቕንዓት"
  },
  "common": {
    "cancel": "ሰርዝ",
    "save": "ኣቐምጥ",
    "confirm": "ኣረጋግጽ",
    "delete": "ሰርዝ",
    "back": "ተመለስ",
    "close": "ዝጋ",
    "edit": "ኣስተኻኽል",
    "search": "ፍለጥ",
    "all": "ኩሉ",
    "loading": "ተጽዕኖ ኣሎ...",
    "error": "ነገር ኣልቦ ኣሎ",
    "notFound": "ኣይተረኽበን",
    "tryAgain": "ተደጊም ሞክር",
    "retry": "ተደጊም ሞክር",
    "undo": "ኣብዳ",
    "pullToRefresh": "ምስል ኣቕምጥ",
    "justNow": "ኣብ ግዜ ኣሎ"
  },
  "auth": {
    "welcome": "እንቋዕ ብደሓን መጻኢ FishMemory",
    "tagline": "ኣማኻሪ ኣርእስታትካ ብWhatsApp፣ ኣሁን ኣብ ጉርሻካ ዘለኻ።",
    "subtitle": "ኣማኻሪ ኣርእስታትካ ብWhatsApp፣ ኣሁን ኣብ ጉርሻካ ዘለኻ።",
    "phoneLabel": "ቁጽሪ WhatsAppካ",
    "phoneHint": "ኮድ ማረጋገጺ ብWhatsApp ክልእኽል እናልከልና",
    "invalidPhone": "ቁጽሪ ተሓትቶ ኣሎ ኣስገብር",
    "continue": "ቀጺሉ",
    "enterPhone": "ቁጽሪ WhatsAppካ ኣስገብር",
    "phonePlaceholder": "ቁጽሪ ስልኪ",
    "sendCode": "ኮድ ላክ",
    "verifyTitle": "ቁጽሪካ ኣረጋግጽ",
    "otpSentTo": "6 ቁጽሪ ኮድ ኣብ {{phone}} ብWhatsApp ተልእኮ",
    "enterFullCode": "ሓላፍካ 6 ቁጽሪ ኣስገብር",
    "invalidOtp": "ኮድ ዘይተሓተተ። ተደጊም ሞክር።",
    "otpFailed": "ኮድ ምልክት ኣልከልን ኣሎ። ተደጊም ሞክር።",
    "otpResent": "ኮድ ተመላለሰ",
    "resendIn": "{{seconds}} ሰከንድ ውሽጢ ኣቕምጥ",
    "resendCode": "ኮድ ኣቕምጥ",
    "enterOtp": "ብWhatsAppካ ዘለኻ ኮድ ኣስገብር",
    "verify": "ኣረጋግጽ",
    "resend": "ኮድ ኣቕምጥ",
    "wrongNumber": "ቁጽሪ ሓሙኹ?",
    "backToPhone": "ተመለስ ናብ ስልኪ",
    "editPhone": "ቁጽሪ ስልኪ ኣስተኻኽል",
    "error": "ሓበሬታ ስሕተት",
    "setupTitle": "ንምምሕዳር ክንጀምር",
    "setupSubtitle": "ንዝተለዋዋጠ ኣብ ቕንዓት ክትቕየር ትኽእል ኢኻ።",
    "namePlaceholder": "ስምካ",
    "letsGo": "ምምሕዳር ኣጠና",
    "skipForNow": "ኣብዚ ግዜ ኣልፍ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "መልእኽቲ ኣጽዕነ...",
    "inputPlaceholder": "መልእኽቲ ኣጽዕነ...",
    "typing": "FishMemory ኣብ ምጽዳቕ ኣሎ...",
    "online": "ኣብ መስመር",
    "connecting": "ኣብ ምያዳ...",
    "reconnecting": "ኣብ ምያዳ ኣምጽዋር...",
    "offline": "ኣይነበረን",
    "empty": "መነሻ ንቻት ኣስጀምር",
    "emptyHint": "ኣርእስታታት ፍጠር፣ መደብ ኣቕምጥ ወይ ኣገዳሲ ጠይቅ።",
    "emptyAction": "ናይ ምስል ኣርእስታ ላክ",
    "actions": "እተወሳኺ ኣርእስታታት",
    "keep": "መልእኽቲ ኣብ ሓሳብ ኣርከብ",
    "clearTitle": "ቻት ኣጽድቅ",
    "clearConfirm": "ኩሉ መልእኽቲ ካብ ዚሕብር መሳርሒ ትፈልጥ? እዚ ኣይተመለስን።",
    "clear": "ቻት ኣጽድቅ",
    "optionSelected": "ተመርጸ: {{label}}",
    "sendingSelection": "ኣብ ምልክት...",
    "connectionLost": "ኣብ ምያዳ ኣምጽዋር..."
  },
  "reminders": {
    "title": "ናይ እኔ ኣርእስታታት",
    "active": "ኣስተሓሳስባ",
    "today": "ሎሚ",
    "thisWeek": "እዚ ሳምንት",
    "history": "ታሪኽ",
    "items": "ንጥልታት",
    "emptyTitle": "ኣርእስታ ኣይኮነን",
    "emptySubtitle": "ካብ ቻት ኣርእስታ ፍጠር እንተኾይኑ ኣብዚ ክትርከብ ኢካ።",
    "emptyAction": "ቻት ክፈት",
    "filterActive": "ኣስተሓሳስባ",
    "filterToday": "ሎሚ",
    "filterWeek": "እዚ ሳምንት",
    "filterHistory": "ታሪኽ",
    "emptyState": "ኣርእስታ ኣይኮነን። ቻት ኣስጀምር!",
    "swipeDone": "ተጠናቀረ",
    "swipeSnooze": "ምቕጻል",
    "swipeDelete": "ሰርዝ",
    "search": "ኣርእስታታት ፍለጥ...",
    "upcoming": "ዝቕጽል",
    "completed": "ተጠናቀረ",
    "overdue": "ዝተሓለፈ",
    "tomorrow": "ነገ",
    "synced": "ተዛማኒ {{value}}",
    "swipeHint": "ኣርእስታ ምምዝጋብ ንተጨማሪ እተወሳኺታት",
    "noResults": "ኣርእስታ ኣይኣተወን ኣብ ፍለጥካ",
    "noResultsHint": "ቃል ሓደሽ ሞክር ወይ ፍለጥ ኣጽድቅ",
    "deleteAllFailed": "ኩሉ ኣርእስታታት ምስርዝ ኣልከነ"
  },
  "calendar": {
    "title": "ካሌንደር",
    "today": "ሎሚ",
    "tomorrow": "ነገ",
    "completed": "ተጠናቀረ",
    "noEvents": "ነገር ዘይተደሊአ",
    "noEventsSubtitle": "ቀን ምረጽ ንምርካብ ኣርእስታታትን ካሌንደር ክሳብ ኣብዚ ክትርከብ ኢካ።",
    "googleEvent": "Google Calendar",
    "legendActive": "ኣስተሓሳስባ",
    "legendRecurring": "ዝተደገፈ",
    "legendDone": "ተጠናቀረ",
    "legendGoogle": "Google",
    "previousMonth": "ዝሓለፈ ወርሒ",
    "nextMonth": "ዝቕጽል ወርሒ",
    "previousYear": "ዝሓለፈ ዓመት",
    "nextYear": "ዝቕጽል ዓመት",
    "goToToday": "ናብ ሎሚ ሂድ",
    "all": "ኩሉ",
    "active": "ኣስተሓሳስባ",
    "done": "ተጠናቀረ",
    "paused": "ተሰናይ"
  },
  "settings": {
    "title": "ቕንዓት",
    "profile": "ፕሮፋይል",
    "name": "ስም ኣሳይ",
    "enterName": "ስምካ ኣስገብር",
    "language": "ቋንቋ",
    "uiLanguage": "ቋንቋ መተግበሪ",
    "uiLanguageHelp": "ኣብዚ መሳርሒ ብብቕዓት መተግበሪ ቋንቋ፣ ምልክታት ካሌንደርን ኣብ አቀማመጥ ይቀየር።",
    "serverLanguage": "ቋንቋ ቻት",
    "serverLanguageHelp": "ቋንቋ ንሰርቨር መልስን ኣርእስታት ይቀየር ንኣካውንትካ።",
    "timezone": "የሰዓት ክልል",
    "currentTimezone": "ኣሁን የሰዓት ክልል",
    "timezoneHelp": "ኩሉ ዝተወሰነ ግዜ ኣርእስታታት ብዚ የሰዓት ክልል ይታያሉ።",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "የሰዓት ክልል ኣቐምጥ",
    "timezoneSaved": "የሰዓት ክልል ተሻሽሎ",
    "detect": "ምልክት",
    "detectFailed": "የሰዓት ክልል ኣልተለወጠን",
    "autoDetect": "ካብ GPS ራስሓዊ ምልክት",
    "notifications": "ማሳወቂያታት",
    "notificationsHelp": "ኣርእስታታት ኣብ ኋላ ዝተደገፉ ማሳወቂያታት ይቆጥቑ። የመሳርሒ ደረጃ ፍቓድ ኣብ ስልኪካ ቕንዓት ይተኻእላሉ።",
    "pushEnabled": "ማሳወቂያ ኣብ ፍቓድ",
    "autoDoneOnFire": "ብራስ እንተተኸናኸነ",
    "autoDoneOnFireDesc": "ኣብ ኣይኮነን ኣርእስታታት እስከ እርከብ ድሕሪ ኣስተሓሳስብ ይቆዩ።",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ተገናእተ",
    "googleDisconnected": "ዘይተገናነተ",
    "googleConnectedHelp": "ኣዳራሽ ኣርእስታታት ናብ ካሌንደርካ ብራስ ምስማር ይኽእል።",
    "googleDisconnectedHelp": "Google Calendar ኣገናኝ ንምስማር ኣርእስታታትን ክስርዝ ይረኽብ።",
    "googleConnectFailed": "Google Calendar ኣገናኝ ኣልከነ",
    "connected": "ተገናእተ",
    "disconnected": "ዘይተገናነተ",
    "connect": "ኣገናኝ",
    "disconnect": "ኣልጋን",
    "autoSync": "ኣዳራሽ ኣርእስታታት ራስሓዊ ምስማር",
    "autosync": "ኣዳራሽ ኣርእስታታት ራስሓዊ ምስማር",
    "subscription": "ኣባልነት",
    "trialUsed": "ሙከራ: {{used}}/{{total}} ተጠቀምቲ",
    "trialStatus": "ሙከራ ኣሎ",
    "activeStatus": "ኣባልነት ኣስተሓሳስባ",
    "expiredStatus": "ኣባልነት ዝተሰርዘ",
    "unsubscribedStatus": "ኣባል ኣይኮነን",
    "about": "ኣብ ስለ",
    "version": "ስሪት",
    "logout": "ኣውጽእ",
    "logoutTitle": "ኣውጽእ",
    "logoutConfirm": "እርግጠኛ ኢኻ እትውጽእ?",
    "noName": "ስም ኣይተሰጠን",
    "serverConnection": "ኣገናኝ ሰርቨር",
    "serverUrl": "URL ሰርቨር",
    "serverEdit": "ኣስተኻኽል",
    "saveReconnect": "ኣቐምጥ ኣብ ምያዳ ኣገናኝ",
    "resetDefault": "ኣካላዊ ኣቀማመጥ ኣቀምጥ",
    "invalidServerUrlTitle": "URL ሰርቨር ዘይተሓተተ",
    "invalidServerUrlMessage": "ኣካላዊ http ወይ https URL ሰርቨር ኣስገብር፣ ምሳሌ https://example.com",
    "uiLanguageChangeFailed": "ቋንቋ መተግበሪ ምቀየር ኣልተሳነየን። ተደጊም ሞክር።",
    "serverLanguageChangeFailed": "ቋንቋ ቻት ምቀየር ኣልተሳነየን። ተደጊም ሞክር።",
    "timezoneChangeFailed": "የሰዓት ክልል ምቀየር ኣልተሳነየን። ተደጊም ሞክር።",
    "autoSyncChangeFailed": "ራስሓዊ ምስማር ምቀየር ኣልተሳነየን። ተደጊም ሞክር።",
    "nameChangeFailed": "ስም ኣሳይ ምቀየር ኣልተሳነየን። ተደጊም ሞክር።",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ዝርዝር ኣርእስታ",
    "editTime": "ግዜ ኣስተኻኽል",
    "rename": "ስም ኣስተኻኽል",
    "snooze": "ምቕጻል",
    "snooze15": "15 ደቂቕ ምቕጻል",
    "pause": "ተሰናይ",
    "pauseReminder": "ኣርእስታ ተሰናይ",
    "resume": "ኣቐፅል",
    "resumeReminder": "ኣርእስታ ኣቐፅል",
    "skip": "ቀጺሉ ኣቕሪብ",
    "skipOccurrence": "ዝኾነው ክሳብ ቀጺሉ",
    "syncGoogle": "ናብ Google ምስማር",
    "delete": "ሰርዝ",
    "deleteTitle": "ኣርእስታ ምስርዝ",
    "deleteConfirm": "እዚ ኣርእስታ ብምስርዝ ክንተገደስ ኢልካ።",
    "deleteRecurringTitle": "ዝተደገፈ ኣርእስታ ምስርዝ",
    "deleteRecurringMessage": "ዝኾነው ክሳብ ቀጺሉ ወይ ኩሉ ስርዓት ምስርዝ?",
    "deleteThisOccurrence": "ዝኾነው ክሳብ ቀጺሉ",
    "deleteEntireSeries": "ኩሉ ስርዓት ምስርዝ",
    "done": "ተጠናቀረ",
    "markDone": "ኣርእስታ ኣስተሓስብ",
    "undo": "ኣብዳ",
    "undoPrompt": "እንተ ኣስተሓሳስበካ ድጋሚ ኣብዳ ኣድርግ።",
    "recurring": "ዝተደገፈ",
    "nextRun": "ቀጺሉ ምምራት",
    "oneTime": "ናይ አንድ ጊዜ",
    "pending": "ተጠባበቐ",
    "sent": "ተልእኮ",
    "paused": "ተሰናይ",
    "active": "ኣስተሓሳስባ",
    "snoozed": "ተቕጻል",
    "localTime": "ኣብ ናይ እንተኾነ ግዜ ይታያል",
    "recurrence": "ዝተደገፈ ግዜ",
    "created": "ተፈጢረ",
    "tags": "መለኪያታት",
    "fireCount": "ግዜ ተኸናኸነ",
    "actions": "እተወሳኺታት",
    "none": "ኣይኮነን",
    "snoozeFailed": "ኣርእስታ ምቕጻል ኣልተሳነየን",
    "pauseFailed": "ኣርእስታ ተሰናይ ኣልተሳነየን",
    "resumeFailed": "ኣርእስታ ኣቐፅል ኣልተሳነየን",
    "skipFailed": "ኣርእስታ ቀጺሉ ኣልተሳነየን",
    "doneFailed": "ኣርእስታ ኣስተሓስብ ኣልተሳነየን",
    "undoFailed": "ኣርእስታ ሁኔታ ኣብዳ ኣልተሳነየን",
    "deleteFailed": "ኣርእስታ ምስርዝ ኣልተሳነየን",
    "rescheduleTitle": "ኣድሓን?",
    "rescheduleMsg": "እዚ ኣርእስታ ዝተሓለፈ እዩ። ኣድሓን ትፈልጥ?",
    "reschedule15": "ኣብ 15 ደቂቕ",
    "reschedule60": "ኣብ 1 ሰዓት",
    "keepOverdue": "እንተዘይተቐየረ ኣብዚ ኣብድሕር"
  },
  "onboarding": {
    "slide1Title": "እንቋዕ ብደሓን መጻኢ FishMemory",
    "slide1Sub": "ናይ ግል ኣርእስታ ኣማኻሪ — ብWhatsApp ኣብ ጉርሻካ ተሰሪሐ።",
    "slide2Title": "ብቀላል ቻት ኣድርግ",
    "slide2Sub": "ኣርእስታታት ከም ኣስበካ ኣጽዕነ: \"ነገ ሰኣት 3 ኣቦኻ ለኣለይ\" — ንቀጽልና እንተዘይተሓለፈ።",
    "slide3Title": "ነገር ኣይትርሕዕን",
    "slide3Sub": "ብግዜ ማሳወቂያታት ተቐባል፣ ብመለኪያታት ውድብ ኣድርግ፣ ኩሉ ነገር ኣብ ርእሰ ሓሳብ ክትኹን።",
    "getStarted": "ኣስጀምር",
    "next": "ቀጺሉ",
    "firstReminderTitle": "ናይ መጀመርታ ኣርእስታ ፍጠር!",
    "firstReminderHint": "ከም እዚ ሞክር:",
    "firstReminderExample": "\"ነገ 9 ሰዓት ማይ ምጠጣ\" ኣርእስታ ኣጽዕነ",
    "gotIt": "ተረድአለይ!",
    "notifRationaleTitle": "ብግዜ ክትኹን",
    "notifRationaleBody": "FishMemory ንማሳወቂያታት ብግዜ ክትረኽብ ይፈልጥ። ኣካል ኣርእስታታት እንተፈጠረ ብብቕዓት ማሳወቂያታት ትተላለፊ።",
    "notifRationaleAllow": "ማሳወቂያታት ኣፍቅር",
    "notifRationaleLater": "ኣብ ኋላ ምንባር",
    "swipeHint": "ቀኝ ኣድርግ ንፍጥነት እተወሳኺታት →",
    "calendarDragHint": "ንምትሕብባር ኣቕምጥ ↕"
  }
}
